import { OrderedSet } from 'immutable'

/** @returns {Immutable.Map<string, ItemRecord>} */
const getItems = state => state.items.items

/**
 * @template {Immutable.List<string> | Immutable.OrderedSet<string>} T
 * @param {object} state
 * @param {T} itemIds
 * @returns {T extends Immutable.List ? Immutable.List<ItemRecord> : Immutable.OrderedSet<ItemRecord>}
 */
export const getItemsByIds = (state, itemIds) => itemIds.map(itemId => getItems(state).get(itemId))

/**
 * @param state
 * @param {string} itemId
 * @returns {?ItemRecord}
 */
export function selectItemById(state, itemId) {
  return getItems(state).get(itemId)
}


/**
 * Return item ids for a batch
 * @param {object} state
 * @param {number} batchId
 * @returns {Immutable.OrderedSet<string>}
 */
export function selectBatchItemIds(state, batchId) {
  return state.items.batches.get(batchId, OrderedSet())
}
